import React, { Component } from 'react';
import { default as WeeklyScheduleContainer } from './WeeklyScheduleContainer';
import { default as ScheduleWeekCalendar } from '../../../common/ScheduleWeekCalendar';

export class AgentSchedule extends Component {
    render() {
        let { agentID, agentName, teamID, muID, date } = this.props;
        return (
            <div>
                <WeeklyScheduleContainer                                 
                    agentID={agentID}
                    agentName={agentName}
                    teamID={teamID}
                    muID={muID}
                    date={date}                                                          
                     />
                <ScheduleWeekCalendar 
                    date={date}
                    />
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/features/schedules/Schedules/AgentSchedule/AgentSchedule.js